import Vue from 'vue';
import Vuex from 'vuex';
import Vapi from 'vuex-rest-api';
import Endpoints from '@/components/Endpoints.js';
import Certificates from '@/components/Certificates.js';
import { setup } from 'axios-cache-adapter';

Vue.use(Vuex);

const axios = setup({
  cache: {
    maxAge: 15 * 60 * 1000,
    exclude: {
      query: false
    }
  }
});

let state = {};

Certificates.List.forEach(e => {
  state[e.listProperty] = {};
});

Endpoints.List.forEach(e => {
  state[e.getProperty] = {};
  state[e.listProperty] = {};
});

const apiUrl = 'https://padres.dimin.io/breitbard-api';
const certUrl = 'https://di-breitbard.herokuapp.com/certificatejson';

const api = new Vapi({
  state,
  axios
});

Certificates.List.forEach(e => {
  let s = encodeURIComponent(e.slug);
  api.get({
    action: e.listAction,
    property: e.listProperty,
    path: () => `${certUrl}/${e.slug}`
  });
});

Endpoints.List.forEach(e => {
  let s = Endpoints.safe(e.slug);
  api.get({
    action: e.getAction,
    property: e.getProperty,
    path: ({ id }) => `${apiUrl}/${e.slug}/${id}/`
  });
  api.get({
    action: e.listAction,
    property: e.listProperty,
    path: ({ page = 1 }) => `${apiUrl}/${e.slug}/?page=${page}`
  });
  api.get({
    action: e.searchAction,
    property: e.searchProperty,
    path: ({ page = 1, query }) =>
      `${apiUrl}/${e.slug}/?page=${page}&search=${query}`
  });
});

export default new Vuex.Store(api.getStore());
